<template>
  <v-container fluid :style="{'background-image': 'url(' + require('../assets/newforest.jpg') + ')'}">

  
    <vue-particles
      color="#dedede"
      :particleOpacity="0.2"
      :particlesNumber="30"
      shapeType="circle"
      :particleSize="12"
      linesColor="#dedede"
      :linesWidth="0"
      :lineLinked="false"
      :lineOpacity="0.4"
      :linesDistance="150"
      :moveSpeed="1"
      :hoverEffect="true"
      hoverMode="push"
      :clickEffect="false"
      clickMode="push"
    >
    </vue-particles>


    <v-layout row wrap justify-center>

      <v-flex xs12 md6>
        <v-container flex>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              class="mx-auto"
              max-width="600"
              light
            >
              <v-carousel hide-controls>
                <v-carousel-item
                  v-for="(item,i) in cd1"
                  :key="i"
                  :src="item.src"
                  reverse-transition="fade"
                  transition="fade"
                ></v-carousel-item>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out black v-card--reveal display-3 white--text"
                    style="height: 100%;"
                  >
                    £8.70
                  </div>
                </v-expand-transition>
              </v-carousel>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-btn
                  absolute
                  color="red darken-4"
                  class="white--text"
                  title="Opens our Bandcamp store page in a new tab."
                  fab
                  large
                  right
                  top
                  v-on:click.native="launchCd"
                >
                  <v-icon>shopping_cart</v-icon>
                </v-btn>
                <div class="font-weight-light grey--text title mb-2">Now Available</div>
                <h3 class="display-1 font-weight-light orange--text mb-2">Commemorate CD</h3>
                <div class="font-weight-light title mb-2">
                  <p>The debut Commemorate album CD version includes the Commemorate single, Boys of Summer and two CD only unplugged versions of Commemorate and Undressed.</p>
                  <p>Includes digital album.</p>
                  <p style="color:red">Shipping from the US</p>

                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-container>
      </v-flex>

      <v-flex xs12 md6>
        <v-container flex>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              class="mx-auto"
              max-width="600"
              light
            >
              <v-carousel hide-controls>
                <v-carousel-item
                  v-for="(item,i) in tee1"
                  :key="i"
                  :src="item.src"
                  reverse-transition="fade"
                  transition="fade"
                ></v-carousel-item>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out black v-card--reveal display-3 white--text"
                    style="height: 100%;"
                  >
                    £13.00
                  </div>
                </v-expand-transition>
              </v-carousel>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-btn
                  absolute
                  color="red darken-4"
                  class="white--text"
                  title="Opens our Bandcamp store page in a new tab."
                  fab
                  large
                  right
                  top
                  v-on:click.native="launch"
                >
                  <v-icon>shopping_cart</v-icon>
                </v-btn>
                <div class="font-weight-light grey--text title mb-2">Original Design</div>
                <h3 class="display-1 font-weight-light orange--text mb-2">Witch of the Vale Logo Teeshirt</h3>
                <div class="font-weight-light title mb-2">
                  <p>Witch of the Vale Logo T-Shirt. 100% cotton, soft style by Gildan.</p>
                  <p>Available in all sizes.</p>
                  <p style="color:red">Normally ships out within 5 days</p>

                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-container>
      </v-flex>

      <v-flex xs12 md6>
        <v-container flex>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              class="mx-auto"
              max-width="600"
              light
            >
              <v-carousel hide-controls>
                <v-carousel-item
                  v-for="(item,i) in tee2"
                  :key="i"
                  :src="item.src"
                  reverse-transition="fade"
                  transition="fade"
                ></v-carousel-item>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out black v-card--reveal display-3 white--text"
                    style="height: 100%;"
                  >
                    £13.00
                  </div>
                </v-expand-transition>
              </v-carousel>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-btn
                  absolute
                  color="red darken-4"
                  class="white--text"
                  title="Opens our Bandcamp store page in a new tab."
                  fab
                  large
                  right
                  top
                  v-on:click.native="launch2"
                >
                  <v-icon>shopping_cart</v-icon>
                </v-btn>
                <div class="font-weight-light grey--text title mb-2">New Design</div>
                <h3 class="display-1 font-weight-light orange--text mb-2">We're Not Good People T-Shirt</h3>
                <div class="font-weight-light title mb-2">
                  <p>Witch of the Vale Logo T-Shirt. 100% cotton, soft style by Gildan.</p>
                  <p>Our second t-shirt design as voted for in a poll.</p>
                  <p style="color:red">Normally ships out within 5 days</p>
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-container>
      </v-flex>

      <v-flex xs12 md6>
        <v-container flex>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              class="mx-auto"
              max-width="600"
              light
            >
              <v-carousel hide-controls>
                <v-carousel-item
                  v-for="(item,i) in tote"
                  :key="i"
                  :src="item.src"
                  reverse-transition="fade"
                  transition="fade"
                ></v-carousel-item>
                <v-expand-transition>
                  <div
                    v-if="hover"
                    class="d-flex transition-fast-in-fast-out black v-card--reveal display-3 white--text"
                    style="height: 100%;"
                  >
                    £9.00
                  </div>
                </v-expand-transition>
              </v-carousel>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-btn
                  absolute
                  color="red darken-4"
                  class="white--text"
                  title="Opens our Bandcamp store page in a new tab."
                  fab
                  large
                  right
                  top
                  v-on:click.native="launch2"
                >
                  <v-icon>shopping_cart</v-icon>
                </v-btn>
                <!-- <div class="font-weight-light grey--text title mb-2">New Design</div> -->
                <h3 class="display-1 font-weight-light orange--text mb-2">Witch of the Vale Tote Bag</h3>
                <div class="font-weight-light title mb-2">
                  <p>Ethically produced, Westford Mill 100% cotton tote bag with Witch of the Vale logo.</p>
                  <p style="color:red">Normally ships out within 5 days</p>
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-container>
      </v-flex>      

    </v-layout>
  </v-container>
</template>

<style scoped>
  #particles-js { position: fixed; top: 44px; left: 0; width: 100%; height: 80%; } 
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .3;
    position: absolute;
    width: 100%;
  }

</style>

<style lang="stylus">
  #example-custom-transition
    .fade
      &-enter-active, &-leave-active, &-leave-to
        transition: .3s ease-out
        position: absolute
        top: 0
        left: 0

      &-enter, &-leave, &-leave-to
        opacity: 0
</style>

<script>

  const tshirt1 = require('../assets/tshirt1.jpg');
  const tshirt2 = require('../assets/tshirt2.jpg');
  const tshirt3 = require('../assets/tshirt3.jpg');
  const cdImage = require('../assets/cd-image.jpg');
  const toteBag = require('../assets/tote-bag.jpg');

  

  const notGoodPeople1 = require('../assets/notgoodpeople1.jpg');
  export default {
    data () {
      return {
        cd1: [
          {
            src: cdImage
          }
        ],
        tee1: [
          {
            src: tshirt1
          },
          {
            src: tshirt2
          },
          {
            src: tshirt3
          },
        ],
        tee2: [
          {
            src: notGoodPeople1
          }
        ],
        tote: [
          {
            src: toteBag
          }
        ]

      }
    },
    methods: {
      launch: function () {
        window.open('https://witchofthevale.bandcamp.com/merch/witch-of-the-vale-t-shirt', '_blank');
      },
      launch2: function () {
        window.open('https://witchofthevale.bandcamp.com/merch/were-not-good-people-t-shirt', '_blank');
      },
      launchCd: function () {
        window.open('https://witchofthevale.bandcamp.com/album/commemorate-2', '_blank');
      },
      launchTote: function () {
        window.open('https://witchofthevale.bandcamp.com/merch/tote-bag', '_blank');
      },
    }
  }
</script>
